import { createTheme } from "@mui/material";
import { enUS, frFR, plPL } from "@mui/material/locale";
import { Localization } from "@mui/material/locale";
import { LocaleUtil } from "@utils/locale.util";

const { palette } = createTheme();
const { augmentColor } = palette;

const createColor = (mainColor: string) =>
  augmentColor({ color: { main: mainColor } });

const localeMap = new Map<string, Localization>([
  ["en", enUS],
  ["fr", frFR],
  ["pl", plPL],
]);

const getTheme = (lang: string) => {
  const locale =
    localeMap.get(LocaleUtil.getRootLanguageCodeFromLocaleString(lang)) || enUS;

  return createTheme(
    {
      components: {
        MuiTextField: {
          defaultProps: {
            slotProps: {
              inputLabel: {
                shrink: true,
              },
            },
          },
        },
        MuiButton: {
          variants: [
            {
              props: { variant: "outlined", color: "primary" },
              style: {
                borderColor: palette.primary.main,
              },
            },
          ],
          defaultProps: {
            style: {
              borderRadius: "44px",
              boxShadow: "none",
            },
          },
        },
        MuiSkeleton: {
          variants: [
            {
              props: { variant: "rectangular" },
              style: {
                borderRadius: "4px",
              },
            },
          ],
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              color: "#171A1FFF",
              fontSize: "14px",
              fontWeight: 600,
            },
          },
        },
        MuiTab: {
          styleOverrides: {
            root: {
              fontSize: "1rem",
            },
          },
        },
      },
      palette: {
        primary: createColor("#1E64DDFF"),
        text: {
          secondary: "#565D6DFF",
        },
      },
      shape: {
        borderRadius: 4,
      },
      typography: {
        fontFamily: ['"Rubik"', '"Helvetica"', '"Arial"', "sans-serif"].join(
          ",",
        ),
        button: {
          textTransform: "none",
        },
      },
    },
    locale,
  );
};

export default getTheme;
